/* Keep the embedded UpCart drawer aligned with the theme's shared type system.
   The app exposes an open shadow root; no cart data or behavior is changed. */
(function () {
  'use strict';
  var attempts = 0;
  var timer;
  function applyCartDesign() {
    var host = document.getElementById('upCart');
    var root = host && host.shadowRoot;
    if (root) {
      if (!root.querySelector('[data-mw-store-design]')) {
        var style = document.createElement('style');
        style.setAttribute('data-mw-store-design', '');
        style.textContent = '#UpcartPopup { font-family: Inter,system-ui,sans-serif !important; color:#2c2620; }' +
          '#UpcartPopup :is(p,button,input,select,textarea,a) { font-family:Inter,system-ui,sans-serif !important; }' +
          '#UpcartPopup :is(h1,h2,h3,h4,h5,h6), #UpcartPopup :is(h1,h2,h3,h4,h5,h6) a { font-family:Fraunces,Georgia,serif !important; font-weight:500 !important; line-height:1.2 !important; letter-spacing:-.02em !important; }' +
          '#UpcartPopup :is(h3,h4) { font-size:22px !important; }' +
          '#UpcartPopup p { font-size:15.5px !important; line-height:1.65 !important; }';
        root.appendChild(style);
      }
      return true;
    }
    return false;
  }
  if (!applyCartDesign()) {
    timer = window.setInterval(function () {
      attempts += 1;
      if (applyCartDesign() || attempts >= 60) window.clearInterval(timer);
    }, 500);
  }
})();
